import { useGLTF,useTexture, Text3D, Center } from '@react-three/drei'

export default function Notebook(props) {
  const { nodes, materials } = useGLTF('./models/notebook_v01.gltf')
  const colors = props.colors
  const [gradientMap] = useTexture([
    'img/matcap.jpg'
  ])
  const deg= Math.PI*2/360

  const Ring = (props)=>{

    const separation = -0.013
    
    return(
        <>
            <mesh
            geometry={nodes.notebookRing.geometry}
            material={nodes.notebookRing.material}
            position={[-0.04, 0.003, (-0.06-(separation*props.posAdd))]}
            >
            <meshMatcapMaterial matcap={gradientMap} color={props.isDark?colors.night:colors.day}/>
            </mesh>
        </>
    )}




  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Notebook.geometry}
        material={nodes.Notebook.material}
        >
        <meshMatcapMaterial matcap={gradientMap} color={props.isDark?colors.night:colors.day}/>
        </mesh>
      <mesh
        geometry={nodes.notebookShadow.geometry}
        material={nodes.notebookShadow.material}
        position={[0, -0.00051, 0]}
        >
        <meshBasicMaterial color={props.isDark?colors.shadowNight:colors.shadowDay}/>
        
        </mesh>

        <Ring posAdd={0} isDark={props.isDark}/>
        <Ring posAdd={1} isDark={props.isDark}/>
        <Ring posAdd={2} isDark={props.isDark}/>
        <Ring posAdd={3} isDark={props.isDark}/>
        <Ring posAdd={4} isDark={props.isDark}/>
        <Ring posAdd={5} isDark={props.isDark}/>
        <Ring posAdd={6} isDark={props.isDark}/>
        <Ring posAdd={7} isDark={props.isDark}/>
        <Ring posAdd={8} isDark={props.isDark}/>
        <Ring posAdd={9} isDark={props.isDark}/>
      
    </group>   
  )
}

useGLTF.preload('./models/postIt_v01.gltf')
